import Section from "../Section"

import styles from "./CTA.module.scss"
import Image from "../Image"
import Link from "../Link"

const CTA = ({ data }) => {
  const {
    section_teaser,
    section_headline,
    section_subline,
    section_text,
    section_links,
    teaser,
    headline,
    subline,
    text,
    links,
    image,
  } = data

  return (
    <Section
      teaser={section_teaser}
      headline={section_headline}
      subline={section_subline}
      text={section_text}
      links={section_links}
    >
      <div className={styles.cta}>
        <div className={styles.ctaBackground} />
        <div className={styles.ctaInner}>
          <div className={styles.image}>
            {image && (
              <Image
                alt={image?.alt}
                src={image?.permalink}
                fill
                style={{
                  objectFit: "cover",
                  objectPosition: `${image?.focus_css || "center"}`,
                }}
              />
            )}
          </div>
          <div className={styles.content}>
            {teaser && (
              <div
                className={styles.teaser}
                dangerouslySetInnerHTML={{ __html: teaser }}
              />
            )}
            {headline && (
              <h2
                className={styles.headline}
                dangerouslySetInnerHTML={{ __html: headline }}
              />
            )}
            {subline && (
              <div
                className={styles.subline}
                dangerouslySetInnerHTML={{ __html: subline }}
              />
            )}
            {text && (
              <div
                className={styles.text}
                dangerouslySetInnerHTML={{ __html: text }}
              />
            )}
            {links?.length > 0 && (
              <div className={styles.links}>
                {links.map((link, i) => (
                  <Link key={i} link={link} inverted />
                ))}
              </div>
            )}
          </div>
        </div>
      </div>
    </Section>
  )
}

export default CTA
